import { render, staticRenderFns } from "./HomeStatBlock.vue?vue&type=template&id=2f5662f7&"
import script from "./HomeStatBlock.vue?vue&type=script&lang=js&"
export * from "./HomeStatBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports